import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { Link } from 'react-router-dom';
import { fechaRelativa } from '../utils/fecha';

const SliderNotasCat = ({ filteredNews, fotoCompletaCategoriaId = null }) => {


    return (
        <Swiper
            modules={[Navigation, Pagination, A11y, Autoplay]}
            spaceBetween={32}
            slidesPerView={3}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            loop={filteredNews.length > 6}
            watchOverflow={true}
            touchRatio={1.5}
            grabCursor={true}
            speed={650}
            breakpoints={{
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            }}
        >
            {filteredNews.map(news => (
                <SwiperSlide key={news.id}>
                    <Link to={`/noticias/${news.id}`} className="ed-tarjeta">
                        <div
                            className={`ed-tarjeta__foto ${news.category_id === fotoCompletaCategoriaId ? 'ed-tarjeta__foto--completa' : ''}`}
                            style={news.category_id === fotoCompletaCategoriaId ? { '--foto': `url("${news.image_url}")` } : undefined}
                        >
                            <img src={news.image_url} alt={news.title} loading="lazy" decoding="async" />
                        </div>
                        <h2 className="slider-text_notas ed-tarjeta__titulo">{news.title}</h2>
                        <p className="ed-tarjeta__fecha">
                            {fechaRelativa(news.fecha_publicacion || news.updated_at || news.created_at)}
                        </p>
                    </Link>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default SliderNotasCat;
